module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.546 12h10.91c.462 0 .714.565.418.937l-5.454 6.857a.53.53 0 01-.838 0l-5.455-6.857c-.296-.372-.043-.937.42-.937z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/basic/asda-caret-down.svg
// module id = 629
// module chunks = 0